<template>
  <div>
    <div v-if="groupedLoans['DEFAULTED']">
      <div class="small card-title font-weight-bold mt-3" v-if="showStatusName">{{$t('LoansPage.status.DEFAULTED')}}</div>
      <LoanCard v-for="loan in groupedLoans['DEFAULTED']" :key="loan.id" :loan="loan"
                :showFullDetailsForWrittenOff="showFullDetailsForWrittenOff"></LoanCard>
    </div>
    <div v-if="pendingApplications.length > 0">
      <div class="small card-title font-weight-bold mt-3" v-if="showStatusName">{{$t('LoansPage.status.PENDING')}}</div>
      <LoanApplicationCard v-for="application in pendingApplications" :key="application.id" :application="application"></LoanApplicationCard>
    </div>
    <div v-if="groupedLoans['DELAYED']">
      <div class="small card-title font-weight-bold mt-3" v-if="showStatusName">{{$t('LoansPage.status.DELAYED')}}</div>
      <LoanCard v-for="loan in groupedLoans['DELAYED']" :key="loan.id" :loan="loan"></LoanCard>
    </div>
    <div v-if="groupedLoans['NORMAL_UNPAID']">
      <LoanCard v-for="loan in groupedLoans['NORMAL_UNPAID']" :key="loan.id" :loan="loan"/>
    </div>
    <div v-if="groupedLoans['NORMAL']">
<!--      <div class="small card-title font-weight-bold mt-3" v-if="showStatusName">{{$t('LoansPage.status.NORMAL')}}</div>-->
      <LoanCard v-for="loan in groupedLoans['NORMAL']" :key="loan.id" :loan="loan"></LoanCard>
    </div>
    <div v-if="groupedLoans['CLOSED']">
      <div class="small card-title font-weight-bold mt-3" v-if="showStatusName">{{$t('LoansPage.status.CLOSED')}}</div>
      <LoanCard v-for="loan in groupedLoans['CLOSED']" :key="loan.id" :loan="loan"></LoanCard>
    </div>
    <div v-if="groupedLoans['REFUNDED']">
      <div class="small card-title font-weight-bold mt-3" v-if="showStatusName">{{$t('LoansPage.status.REFUNDED')}}</div>
      <LoanCard v-for="loan in groupedLoans['REFUNDED']" :key="loan.id" :loan="loan"></LoanCard>
    </div>
    <div v-if="groupedApplicationsHistory['WITHDRAWN']">
      <div class="small card-title font-weight-bold mt-3" v-if="showStatusName">{{$t('LoansPage.status.WITHDRAWN')}}</div>
      <LoanApplicationCard v-for="loan in groupedApplicationsHistory['WITHDRAWN']" :key="loan.id" :application="loan"></LoanApplicationCard>
    </div>
    <div v-if="groupedApplicationsHistory['REJECTED']">
      <div class="small card-title font-weight-bold mt-3" v-if="showStatusName">{{$t('LoansPage.status.REJECTED')}}</div>
      <LoanApplicationCard v-for="loan in groupedApplicationsHistory['REJECTED']" :key="loan.id" :application="loan"></LoanApplicationCard>
    </div>
  </div>
</template>

<script>
    import LoanCard from '@shared/components/LoanCard'
    import LoanApplicationCard from '@shared/components/LoanApplicationCard'

    export default {
      name: 'LoansList',
      props: ['loans', 'pendingApplications', 'applicationsHistory', 'showStatusName', 'showFullDetailsForWrittenOff'],
      components: {
        LoanCard,
        LoanApplicationCard
      },
      data () {
        return {
          groupedLoans: [],
          groupedApplicationsHistory: []
        }
      },
      mounted () {
        this.groupedLoans = this.groupByStatus(this.loans)
        this.groupedApplicationsHistory = this.groupByStatus(this.applicationsHistory)
      },
      methods: {
        groupByStatus(loans) {
          return loans.reduce((accumulator, loan) => {
            const status = loan.status
            accumulator[status] = accumulator[status] || []
            accumulator[status].push(loan)
            return accumulator
          }, {})
        }
      }
    }
</script>
